import { endpointKeys } from '../endpoints'
import RestService from './restService'

export const getListOfAllSuppliersService = async () => {
  return await RestService.get(endpointKeys.supplierList)
}
